import 'swiper/css';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import Program from 'wwg-utilities/dist/collections/program';
import ArrowLeft from '../../icons/ArrowLeft';
import { createRef, useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import getRelatedProgramsRequest from '../../../lib/api/getRelatedProgramsRequest';
import TrainingCard from '../TrainingCard';
import { useRegion } from '../../../lib/providers/regionProvider';
import dynamic from 'next/dynamic';
const BrowserOnly = dynamic(()=> import( '../../shared/BrowserOnly'), {
  ssr: false,
})

interface RelatedProgramsProps {
  program: Program;
}
const LIMIT = 5;
const RelatedPrograms: React.FC<RelatedProgramsProps> = ({ program }) => {
  const [swiper, setSwiper] = useState<any>();
  const [page, setPage] = useState(1);
  const [isComplete, setIsComplete] = useState(false);
  const [relatedProgramsData, setRelatedProgramsData] = useState(
    [] as Program[],
  );

  const {
    region: { name },
  } = useRegion();
  const { data: pageOfResults, isLoading: relatedProgramsIsLoading } = useQuery(
    [program?.id, page],
    () => {
      if (program?.id) {
        return getRelatedProgramsRequest(program.id, page, name);
      }
      return null;
    },
  );
  const nextRef = createRef<HTMLDivElement>();
  const prevRef = createRef<HTMLDivElement>();
  useEffect(() => {
    let newResults = [];
    if (pageOfResults) {
      if (page == 1) {
        setIsComplete(false);
        newResults = pageOfResults;
      } else {
        newResults = [...relatedProgramsData, ...pageOfResults];
      }
      setRelatedProgramsData(newResults);
      if (newResults.length % LIMIT != 0) {
        setIsComplete(true);
      }
    }
  }, [pageOfResults]);
  if (!relatedProgramsData?.length && !relatedProgramsIsLoading) {
    return <></>;
  }
  const loadNext = () => {
    setPage(page + 1);
  };
  return (
    <section className="other-programs">
      {relatedProgramsData?.length ? (
        <section className="mx-4 my-10 lg:mx-0">
          <div className="flex items-center justify-between">
            <h3 className="text-2xl font-bold text-primary-dark">
              Other Programs You Might Like
            </h3>
            <section className="flex items-center">
              <figure ref={prevRef}>
                <ArrowLeft
                  onClick={() => {
                    swiper?.slidePrev();
                  }}
                  className="w-10 h-10 p-3 mx-1 border-2 border-solid rounded-full hover:cursor-pointer stroke-white bg-primary hover:bg-white hover:stroke-primary border-primary"
                />
              </figure>
              <figure ref={nextRef}>
                <ArrowLeft
                  onClick={() => {
                    swiper?.slideNext();
                    if (!isComplete) {
                      loadNext();
                    }
                  }}
                  className="w-10 h-10 p-3 mx-1 rotate-180 border-2 border-solid rounded-full hover:cursor-pointer stroke-white bg-primary hover:bg-white hover:stroke-primary border-primary"
                />
              </figure>
            </section>
          </div>
          <BrowserOnly>
            <Swiper
              modules={[Navigation]}
              direction="horizontal"
              spaceBetween={10}
              navigation={{
                nextEl: nextRef.current,
                prevEl: prevRef.current,
              }}
              onSwiper={setSwiper}
              breakpoints={{
                0: {
                  slidesPerView: 1,
                },
                768: {
                  slidesPerView: 2,
                },
                992: {
                  slidesPerView: 2,
                },
                1400: {
                  slidesPerView: 2,
                },
              }}
              className="my-2"
            >
              {relatedProgramsData.map((program: Program) => {
                return (
                  <SwiperSlide
                    key={`${program.id}-swiper-slide`}
                    className="px-2 my-4"
                  >
                    <TrainingCard
                      key={program.id}
                      program={program}
                    />
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </BrowserOnly>
        </section>
      ) : (
        ''
      )}
    </section>
  );
};

export default RelatedPrograms;
